import { Component, Input } from '@angular/core';
import { GraphContainer } from 'src/app/model/generic-graph';

@Component({
  selector: 'app-eps',
  templateUrl: './eps.component.html',
  styleUrls: ['./eps.component.scss'],
})
export class EpsComponent {
  @Input() graphData!: GraphContainer;

  constructor() { }
}
